import { dew as _SnapshotResponseDew } from "./SnapshotResponse";
import { dew as _SnapshotsResponseDew } from "./SnapshotsResponse";
import { dew as _SnapshotDew } from "./Snapshot";
import { dew as _SnapshotSummaryDew } from "./SnapshotSummary";
import { dew as _RestoreOptionsDew } from "./RestoreOptions";
import { dew as _SummarySectionDew } from "./SummarySection";
import { dew as _ChangeTypeDew } from "./ChangeType";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = exports && exports.__exportStar || function (m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  __exportStar(_SnapshotResponseDew(), exports);
  __exportStar(_SnapshotsResponseDew(), exports);
  __exportStar(_SnapshotDew(), exports);
  __exportStar(_SnapshotSummaryDew(), exports);
  __exportStar(_RestoreOptionsDew(), exports);
  __exportStar(_SummarySectionDew(), exports);
  __exportStar(_ChangeTypeDew(), exports);
  return exports;
}